import PatientInvoice from './PatientInvoice';

export default PatientInvoice;
